import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { MatLegacyAutocomplete } from '@angular/material/legacy-autocomplete';
import { LucideIconInput } from '@lucide/angular';

@Component({
  selector: 'ptl-sg-input',
  templateUrl: './sg-input.component.html',
  styleUrls: ['./sg-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SgInputComponent),
      multi: true,
    },
  ],
})
export class SgInputComponent implements ControlValueAccessor {
  @Input() type = 'text';
  @Input() placeholder = '';
  @Input() label = '';
  @Input() description = '';
  @Input() disabled = false;
  @Input() withIcon = false;
  @Input() icon: LucideIconInput;
  @Input() maxLength: number | null = null;
  @Input() matAutocomplete: MatLegacyAutocomplete;

  @Output() inputChange = new EventEmitter<string>();
  @Output() focusoutAction = new EventEmitter<void>();
  @Output() focustEnterAction = new EventEmitter<void>();

  @ViewChild('inputElement') private inputElement: ElementRef<HTMLInputElement>;

  value = '';
  private onChange = (value: string) => {
    // ControlValueAccessor callback
  };
  private onTouched = () => {
    // ControlValueAccessor callback
  };

  writeValue(value: string): void {
    this.value = value || '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onInputChange(event: Event): void {
    const target = event.target as HTMLInputElement;
    this.value = target.value;
    this.onChange(this.value);
    this.inputChange.emit(this.value);
  }

  onBlur(): void {
    this.onTouched();
    this.focusoutAction.emit();
  }

  onFocus() {
    this.focustEnterAction.emit();
  }

  blur(): void {
    this.inputElement?.nativeElement?.blur();
  }
}
